import { frontendURL } from '../../../helper/URLHelper';
import AnalyticsDashboard from './AnalyticsDashboard.vue';

// SECURITY: Only administrators can access the analytics dashboard
// Agents are redirected to conversations
const ANALYTICS_PERMISSIONS = ['administrator'];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/dashboard'),
      name: 'analytics_dashboard',
      meta: {
        permissions: ANALYTICS_PERMISSIONS,
      },
      component: AnalyticsDashboard,
    },
  ],
};
